import styles from '../globals/pages.module.scss'
import ClaimForm from '../components/claimForm/main'

function MakeClaim() {
    return (
        <div className={`${styles.pcpClaimFormContainer}`}>
            <ClaimForm />
        </div>
    )
}

export default MakeClaim
